/**
 * 问卷 C 端路由
 * detail: 表单入口（填写须知 + 我的提交列表）
 * form: 新建/草稿编辑表单
 * submission-detail: 已提交记录详情（含反馈）
 */
const questionnaireRoutes = [
  {
    path: '/questionnaire/detail',
    name: 'QuestionnaireDetail',
    component: () => import('@/views/questionnaire/detail'),
    meta: { title: '表单详情' }
  },
  {
    path: '/questionnaire/form',
    name: 'QuestionnaireForm',
    component: () => import('@/views/questionnaire/form'),
    meta: { title: '表单详情' }
  },
  {
    path: '/questionnaire/submission-detail',
    name: 'QuestionnaireSubmissionDetail',
    component: () => import('@/views/questionnaire/submission-detail'),
    meta: { title: '提交详情' }
  }
]

export default questionnaireRoutes
